import Glide from "@glidejs/glide";

const glideInstances = new WeakMap();

export const glideConfig = (element, config, withSkeletonLoader, skeletonEl) => {
    const existing = glideInstances.get(element);
    if (existing) {
        existing.destroy();
    }

    const glide = new Glide(element, config);
    if (withSkeletonLoader) {
        glide.on("mount.after", () => {
            element.classList.remove("opacity-0");
            element.classList.remove("pointer-events-none");

            if (skeletonEl) skeletonEl.remove();
        });
    }
    
    glide.mount();
    glideInstances.set(element, glide);

    return glide;
};

export function glideCarouselInfiniteBulletConfig(rootEl, glideOptions) {
    const glide = new Glide(rootEl, glideOptions);
    const bulletsContainer = rootEl.querySelector(".glide__bullets");

    const bullets = bulletsContainer.querySelectorAll(".glide__bullet");

    function updateBullets() {
        const total = bullets.length;
        const realIndex = ((glide.index % total) + total) % total;

        bullets.forEach((bullet, i) => {
            bullet.classList.toggle("glide__bullet--active", i === realIndex);
        });
    }

    // Remove Glide's auto-added active class on mount
    glide.on("mount.after", () => {
        bullets.forEach((b) => b.classList.remove("glide__bullet--active"));
        updateBullets();
    });

    glide.on("move.after", updateBullets);

    // Manually hook bullet click behavior
    bullets.forEach((bullet, i) => {
        bullet.addEventListener("click", () => glide.go(`=${i}`));
    });

    glide.mount();
}
